import { useSelector } from 'react-redux'
import Layout from '../../UI/Layout/Layout'
import props from '../../../redux/props'
import Container from '../../UI/Container/Container'
import BackToCube from '../../UI/BackToCube/BackToCube'
import Video from '../../UI/Video/Video'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { s3PublicStoragePrefix } from '../../../utility'

declare global {
  interface Window {
    afopt: any
  }
}

const NewsAlarm: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <Layout headerTransparent disableHeaderPadding>
      <Container className="py-5">
        <BackToCube />
        <div className="text-white mt-10 font-bolder text-5xl leading-[3rem] mx-auto text-center">{t.programPage.headline}</div>
        <a
          href={`${s3PublicStoragePrefix}custom-static-assets/documents/Entwurf_Regierungsprogramm.pdf`}
          className="group inline-flex items-center gap-x-3 mt-10"
          download="Entwurf_Regierungsprogramm.pdf"
        >
          <ArrowDownTrayIcon className="w-8 mx-auto stroke-white" />
          <p className="text-white group-hover:underline">{t.programPage.download}</p>
        </a>
        <Video className="mt-8" />
      </Container>
    </Layout>
  )
}

export default NewsAlarm
